import { pushEventsLog } from '@/redux/actions';
import { deviceWidth } from '@/utils/deviceWidth';
import { MAX_MOBILE_WIDTH } from '@/utils/constants';
import { useDispatch, useSelector } from 'react-redux';
import useStoreContactDetails from 'src/hooks/useStoreContactDetails';
import { getWhatAppRedirectionUrlHelp } from '@/utils/getWhatsAppRedirectionUrl';
import { useStoreSubscriptionConfigs } from 'src/hooks/useStoreSubscriptionConfigs';

export const FloatingWhatsapp = (props) => {
  const dispatch = useDispatch();
  const { storePhone } = useStoreContactDetails();
  const { websiteStatus } = useStoreSubscriptionConfigs();
  const {
    storeData: { store_info, store_id },
    userData,
  } = useSelector((state) => ({
    storeData: state.storeReducer.store,
    userData: state.userReducer,
  }));

  const iconClick = () => {
    if (storePhone) {
      dispatch(
        pushEventsLog({
          event_name: 'Cx_WA_Clicked',
          data: {
            store_id: store_id,
            domain: store_info?.domain,
            page: window.location.href,
            device: deviceWidth <= MAX_MOBILE_WIDTH ? 'Mobile' : 'Desktop',
            cx_number: userData?.data?.phone,
          },
        })
      );
    }
    window.open(getWhatAppRedirectionUrlHelp());
  };

  if (websiteStatus.isNewStoreWebsiteInactive) {
    return null;
  }
  return (
    !!storePhone && (
      <span
        style={
          !props?.overRideDefaultStyle
            ? {
                position: 'fixed',
                bottom: 32,
                right: 32,
              }
            : null
        }
      >
        <img
          src="/assets/images/whatsapp-round.svg"
          width="48px"
          height="48px"
          className="pointer"
          alt="Whatsapp"
          onClick={iconClick}
        />
      </span>
    )
  );
};
